/**
 * UTM passthrough（Asana 1218220248234956）
 *
 * 官網的註冊 CTA 全都是 build 時寫死的網址，後面什麼參數都不帶，所以使用者是從
 * 哪個廣告／EDM／活動頁進官網的，跳到 app.newsleopard.com 的那一刻就整個不見了。
 * 這裡在最早的時機把落地網址上的 utm_* 記下來，再補到站上所有註冊連結後面。
 * 機制與限制寫在 src/utils/utmPassthrough.js。
 */
import {
  captureUtmParams,
  decorateSignupLinks,
  installSignupClickInterceptor,
} from './src/utils/utmPassthrough';

/**
 * ⛔ 這一層 try/catch 不是形式。Gatsby 的 production-app.js 是
 * `apiRunnerAsync('onClientEntry').then(() => …render…)`，後面沒有 `.catch` ——
 * onClientEntry 裡丟出例外會變成 rejected promise，render 那一段永遠不會跑，
 * 整站每一頁都是白畫面，而 console 只留一條 unhandled rejection。
 * 追蹤參數補不到是可以接受的；擋住 render 不是。
 */
const safely = fn => {
  try {
    fn();
  } catch (e) {
    // 故意吞掉：見上方註解。
  }
};

export const onClientEntry = () =>
  safely(() => {
    // hydration 之前就跑，這是拿得到落地網址的最早時機。
    captureUtmParams(window.location.search);
    installSignupClickInterceptor();
  });

export const onRouteUpdate = ({ location }) => {
  // 首次載入與每次站內換頁都會進來。站內換頁的網址通常沒有 utm_*，
  // captureUtmParams 在沒有參數時不覆寫，所以來源不會被換頁清掉。
  safely(() => captureUtmParams(location ? location.search : window.location.search));

  // 讓 React 先把新頁面的 DOM render 出來再掃。用 setTimeout 而不是
  // requestAnimationFrame：頁面在背景分頁被開起來時 rAF 不會觸發。
  setTimeout(() => safely(decorateSignupLinks), 0);
};
